const state = {
    calendario: null,
};

const actions = {
    calendario({commit}, calendario) {
        commit('calendario',calendario)
    }
};

const mutations = {
    calendario(state, calendario) {
        state.calendario = calendario
    }
};

const getters = {
    calendario(state) {
        return state.calendario
    }
}

export const home = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
